const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the LongText form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, minLength, maxLength, rows, required, defaultValue } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // reuse consistent flags
    const { isRequired, isEditable, isOptional, forAction } = moduleRegistration.resolveFieldFlags(required, context);
    const maybeOptional = schema => (isOptional ? Type.Optional(schema) : schema);

    // Build the string schema with constraints
    const stringOptions = {
        title: title,
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        'x-required': isRequired,
        'x-optional': isOptional,
        'x-editable': isEditable,
        'x-rows': rows
    };

    // Add forAction annotation if this field is within a DetailPane with a specific action
    if (forAction) {
        stringOptions['x-forAction'] = forAction;
    }

    // Add length constraints if provided
    if (minLength !== undefined && minLength !== null) {
        stringOptions.minLength = minLength;
    }
    if (maxLength !== undefined && maxLength !== null) {
        stringOptions.maxLength = maxLength;
    }
    if (defaultValue !== undefined && defaultValue !== null) {
        stringOptions.default = defaultValue;
    }

    const longTextSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: longTextSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
